import { Component, ElementRef, Input, OnInit, Output, ViewChild, EventEmitter, SimpleChanges } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { MultiSelectorDetails } from 'src/app/model/multi-selector-details';
import { messages } from 'src/app/resources/messages';
import { CatalogService } from 'src/app/services/catalog.service';

@Component({
  selector: 'country-dropdown',
  templateUrl: './country-dropdown.component.html',
  styleUrls: ['./country-dropdown.component.scss'],
})
export class CountryDropdownComponent implements OnInit {
  @Input() isOptional: boolean = true;
  @Input() displayLabel: string = 'Country';
  @Input() allowMultiSelect: boolean = true;
  @Input() selectorControlName!: AbstractControl<string>;
  @Input() submitted!: string;
  @Input() ariaText!: string;
  @Output() selectedValues = new EventEmitter<string[]>();
  @Input() defaultCountry: MultiSelectorDetails = { id: '', description: [] };

  @ViewChild('countryListReference') countryListRef: ElementRef | undefined;

  public msg = messages;
  public countryList: MultiSelectorDetails[] = [];
  public maxSelectionCount: number | undefined;
  public componentId!: string;
  public selectedValue: any;
  constructor(private catalogService: CatalogService) { }

  ngOnChanges(changes: SimpleChanges): void {
    for (const property in changes) {
      if (changes.hasOwnProperty(property) && !changes[property].firstChange) {
        if (property === "defaultCountry") {
          setTimeout(()=> { this.selectedValue = this.defaultCountry; }, 500);
        }
      }
    }
  }

  ngOnInit(): void {
    this.setDefaultDetails();
    this.getCountriesData();
    this.setMaxlimit();
  }

  private getCountriesData() {
    this.catalogService.getCountries().subscribe((response) => {
      this.countryList = response.data.map(
        (x) => <MultiSelectorDetails>(<unknown>{
          id: x.countryId,
          description: [x.countryName],
        })
      );

      setTimeout(()=> { this.selectedValue = this.defaultCountry; }, 500);
    });
  }

  public setSelectedCountry($event: any) {
    let countryNames: string[] = $event.detail?.selectedItemArray.map(
      (x: MultiSelectorDetails) => x.id
    );
    this.selectedValues.emit(countryNames);
    if (this.maxSelectionCount === 1) {
      this.countryListRef?.nativeElement.closeSelectionPanel();
    }
  }

  private setMaxlimit() {
    if (this.allowMultiSelect) {
      this.maxSelectionCount = undefined;
    } else {
      this.maxSelectionCount = 1;
    }
  }

  private setDefaultDetails() {
    this.componentId = this.displayLabel.replace(' ', '-');
    this.ariaText = `${this.displayLabel} Expandable List. Click or press enter to expand. Use arrow keys or tab to navigate through the list items and Esc key to close expanded list.`;
  }

  public reset() {
    if(!this.defaultCountry?.id || this.defaultCountry?.id !== this.selectedValue?.id){
      this.countryListRef?.nativeElement.resetSelectMenu();
    }
    if(this.defaultCountry?.id){
      this.selectedValue = this.defaultCountry;
    }
  }

  public resetForce() {
    this.countryListRef?.nativeElement.resetSelectMenu();
  }

  public getAllCountries(): string[] {
    let allCountries = this.countryList.map(
      (x: MultiSelectorDetails) => x.id!);
    return allCountries;
  }
}
